/** Ensures a safe absolute URL for opening in a new tab. */
export function toExternalHref(url) {
  const u = String(url || "").trim();
  if (!u) return "";
  if (/^https?:\/\//i.test(u)) return u;
  return `https://${u}`;
}
